import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import {
    Autocomplete,
    Avatar,
    Badge,
    Box,
    Button,
    Chip,
    IconButton,
    Paper,
    Popper,
    TextField,
    Tooltip
} from "@mui/material";
import {
  accountManager,
  formatCurrencyValue,
  generateCompanyLogo,
  generatProfilePicUrl,
  getLoggedInEmail
} from "../../Utils/Constant";
import { getCoPoData } from "../Services/Proposals";
import emptyImage from "../../assets/images/image.png";
import { ThreeDot } from "react-loading-indicators";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

import {
    DataGridPro,
    GridColDef,
    GridPinnedColumnFields
} from "@mui/x-data-grid-pro";
import { getCompanyRfqMetaFilterData } from "../Services/OrgRepo";
import { getCURFQAssignedToMeFilterMetaFieldsApi } from "../Services/FeasibleRFQ";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EuroIcon from "@mui/icons-material/Euro";
import defaultlogo from "../../assets/icons/noimg.png";
import dayjs from "dayjs";

const getCurrencyIcon = (currency) => {
    switch (currency) {
        case "INR":
            return <CurrencyRupeeIcon sx={{ fontSize: "0.875rem" }} />;
        case "USD":
            return <AttachMoneyIcon sx={{ fontSize: "0.875rem" }} />;
        case "EUR":
            return <EuroIcon sx={{ fontSize: "0.875rem" }} />;
        default:
            return null;
    }
};

export const CoPoDatatable = () => {
    const [rows, setRows] = useState([]);
    const [coPoData, setCoPoData] = useState([]);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const searchInputRef = useRef<HTMLInputElement>(null);

    const [isApplyFilter, setIsApplyFilter] = useState<Boolean>(false);
    const [allRows, setAllRows] = useState([]);

    const [filteredRows, setFilteredRows] = useState(rows);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [selectedCompany, setSelectedCompany] = useState([]);
    // const [selectedCopoStatus, setSelectedCopoStatus] = useState([]);
    const [selectedKeyAccountManager, setSelectedKeyAccountManager] = useState(
        []
    );

    const [selectedTotalCopoValue, setSelectedTotalCopoValue] = useState([]);
    const [filteredSelectedTotalCopoValue, setFilteredSelectedTotalCopoValue] =
        useState([]);
    const staticCopoValueOptions = [
        { title: "0 to 50 Lakhs", value: "V1" },
        { title: "50 Lakhs to 1 Crore", value: "V2" },
        { title: "1 Crore to 10 Crores", value: "V3" },
        { title: "More than 10 Crores", value: "V4" }
    ];

    const [selectedCopoStatusValue, setSelectedCopoStatusValue] = useState([]);
    const [
        filteredSelectedCopoStatusValue,
        setFilteredSelectedCopoStatusValue
    ] = useState([]);

    const staticCopoStatusOptions = [
        { title: "Open", value: "Open" },
        { title: "Closed", value: "Closed" },
        { title: "Void", value: "Void" }
    ];

    // const [filteredSelectedCopoStatus, setFilteredSelectedCopoStatus] = useState(
    //   []
    // );

    const [filterOptions, setFilterOptions] = useState<{
        [key: string]: { title: string; value: string }[];
    }>({});
    const [
        filteredSelectedKeyAccountManager,
        setFilteredSelectedKeyAccountManager
    ] = useState([]);

    const [filteredSelectedCompany, setFilteredSelectedCompany] = useState([]);
    const [removeFilter, setRemoveFilter] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const popperRef = useRef<HTMLDivElement>(null);
    const [isFilterLoading, setIsFilterLoading] = useState<boolean>(false);

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });

    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["COPO_ID", "COPO_Number"],
            right: ["COPO_Status"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );

    const fetchCoPoData = async () => {
        setIsLoading(true);
        try {
            const response = await getCoPoData();

            if (response?.status && Array.isArray(response.data)) {
                const formattedRows = response.data.map(
                    (item: any, index: number) => ({
                        id: index,
                        ...item
                    })
                );

                setCoPoData(response);
                setRows(formattedRows);
                setFilteredRows(formattedRows);
                setAllRows(formattedRows);
            } else {
                setRows([]);
                setFilteredRows([]);
            }
        } catch (error) {
            console.error("Error fetching CoPo data", error);
            setRows([]);
            setFilteredRows([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCoPoData();
    }, []);

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);

        if (search?.length >= 2) {
            const filtered = rows?.filter((row) =>
                ["COPO_Number", "COPO_ID", "CORFQ_ID"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key].toLowerCase().includes(search?.toLowerCase())
                )
            );
            setFilteredRows(filtered);
        } else if (search === "") {
            setFilteredRows(rows);
        }
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);

    useEffect(() => {
        // if (isInitialRender) {
        //   setIsInitialRender(false); // Mark as rendered
        //   return; // Skip first execution
        // }
        const fetchdataInUseEffect = async () => {
            fetchCoPoData();
            setAnchorEl(null);
            setSelectedKeyAccountManager([]);
            // setSelectedCopoStatus([]);
            setSelectedCopoStatusValue([]);
            setSelectedCompany([]);
            setSelectedTotalCopoValue([]);
        };
        fetchdataInUseEffect();
    }, []);

    const handleClearAll = () => {
        setSelectedKeyAccountManager([]);
        // setSelectedCopoStatus([]);
        setSelectedCompany([]);
        setSelectedCopoStatusValue([]);
        setSelectedTotalCopoValue([]);
    };

    const handleClearAllChip = () => {
        setSelectedKeyAccountManager([]);
        // setSelectedCopoStatus([]);
        setSelectedCompany([]);
        setSelectedCopoStatusValue([]);
        setSelectedTotalCopoValue([]);

        setFilteredSelectedKeyAccountManager([]);
        // setFilteredSelectedCopoStatus([]);
        setFilteredSelectedCompany([]);
        setFilteredSelectedCopoStatusValue([]);
        setFilteredSelectedTotalCopoValue([]);

        setFilteredRows(rows);
        setIsApplyFilter(false);
    };
    const handleClose = () => {
        setSelectedKeyAccountManager(filteredSelectedKeyAccountManager);
        // setSelectedCopoStatus(filteredSelectedCopoStatus);
        setSelectedCompany(filteredSelectedCompany);
        setSelectedCopoStatusValue(filteredSelectedCopoStatusValue);
        setSelectedTotalCopoValue(filteredSelectedTotalCopoValue);

        setAnchorEl(null);
        // setFilteredRows(rows);
        // setIsApplyFilter(false);
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (Object.keys(filterOptions)?.length === 0) {
            fetchFilterData();
        }
        setAnchorEl(event.currentTarget);
    };

    function extractOptions(apiResponse: any[], keyName: string) {
        const section = apiResponse.find((item) => item[keyName]);
        if (!section) return [];

        // Handle keyAccountManager separately as it is a direct array
        if (Array.isArray(section[keyName])) {
            return section[keyName].map((name) => ({
                key: name,
                title: name
            }));
        }

        // Handle objects with choices
        if (section[keyName]?.choices) {
            return section[keyName].choices.map(
                (item: { key: any; link_name: any; value: any }) => ({
                    key: item.key || item.link_name || "unknown_key",
                    title: item.value || item.link_name || "Unknown"
                })
            );
        }

        return [];
    }

    const fetchFilterData = async () => {
        setIsFilterLoading(true);
        try {
            const filterData = await getCompanyRfqMetaFilterData();
            const filterDataStatus =
                await getCURFQAssignedToMeFilterMetaFieldsApi();

            let apiResponseCompany = [];
            let apiResponseStatus = [];

            if (filterData?.status) {
                apiResponseCompany = filterData?.data;
            }
            if (filterDataStatus?.status) {
                apiResponseStatus = filterDataStatus?.data;
            }
            type CompanyType = {
                company: string[];
            };
            const companyDetails: string[] = Array.from(
                new Set(rows?.map((item: any) => item?.Company_Name) ?? [])
            );
            const company: CompanyType[] = [{ company: companyDetails }];

            const apiResponse = filterDataStatus?.data;

            const keyAccountManagerOptions = extractOptions(
                apiResponse,
                "key_account_managers"
            );

            const companyOptions = extractOptions(company, "company");

            const obj = {
                keyAccountManagerOptions,
                companyOptions,
                copoStatusOptions: staticCopoStatusOptions,
                copoValueOptions: staticCopoValueOptions
            };
            setFilterOptions(obj);
        } catch (error) {
            console.error("Error fetching filter data:", error);
        } finally {
            setIsFilterLoading(false);
        }
    };

    const filterData = (
        rows: any[],
        filters: {
            copoStatusValue: any;
            keyAccountManager: any;
            company: any;
            totalCopoValue: any;
        }
    ) => {
        return rows?.filter(
            (row: {
                assigneeName: string;
                Key_Account_Manager: string;
                Company_Name: any;
                COPO_Status: any;
                Total_Order_Value: any;
                Currency: any;
            }) => {
                const keyAccountManagerArray =
                    row?.Key_Account_Manager?.toLowerCase()?.split(/\s*,\s*/) ||
                    [];
                const companyArray =
                    row?.Company_Name?.toLowerCase().split(/\s*,\s*/) || [];
                const copoStatusArray =
                    row?.COPO_Status?.toLowerCase().split(/\s*,\s*/) || [];
                // Get filter values, ignore empty ones
                const {
                    keyAccountManager = [],
                    company = [],
                    copoStatusValue = [],
                    totalCopoValue = []
                } = filters;

                const keyAccounManagerMatch =
                    keyAccountManager?.length === 0 ||
                    keyAccountManager?.some((loc: string) =>
                        keyAccountManagerArray.includes(loc.toLowerCase())
                    );

                const companyMatch =
                    company?.length === 0 ||
                    company?.some((cert: string) =>
                        companyArray?.includes(cert.toLowerCase())
                    );

                const copoStatusMatch =
                    copoStatusValue?.length === 0 ||
                    copoStatusValue?.some((status: string) =>
                        copoStatusArray?.includes(status.toLowerCase())
                    );

                const rowValue = parseFloat(row?.Total_Order_Value) || 0;
                let convertedValue = rowValue;
                if (row?.Currency === "USD") {
                    convertedValue = rowValue * 88;
                } else if (row?.Currency === "EUR") {
                    convertedValue = rowValue * 103;
                }
                const copoValueMatch =
                    totalCopoValue?.length === 0 ||
                    totalCopoValue.some((val: string) => {
                        if (val === "V1") return convertedValue <= 5000000;
                        if (val === "V2")
                            return (
                                convertedValue > 5000000 &&
                                convertedValue <= 10000000
                            );
                        if (val === "V3")
                            return (
                                convertedValue > 10000000 &&
                                convertedValue <= 100000000
                            );
                        if (val === "V4") return convertedValue > 100000000;
                        return false;
                    });

                // **Must match ALL applied filters**
                return (
                    copoStatusMatch &&
                    keyAccounManagerMatch &&
                    companyMatch &&
                    copoValueMatch
                );
            }
        );
    };

    const handleApply = async () => {
        setIsApplyFilter(true);
        let filters = {
            keyAccountManager:
                selectedKeyAccountManager?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            company:
                selectedCompany?.map((item) => item?.title.toLowerCase()) || [],
            copoStatusValue:
                selectedCopoStatusValue?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            totalCopoValue:
                selectedTotalCopoValue?.map((item: any) => item?.value) || []
        };
        const filteredResults = filterData(rows, filters);
        setFilteredRows(filteredResults);
        setAnchorEl(null);
        // setFilteredSelectedCopoStatus(selectedCopoStatus);
        setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
        setFilteredSelectedCompany(selectedCompany);
        setFilteredSelectedCopoStatusValue(selectedCopoStatusValue);
        setFilteredSelectedTotalCopoValue(selectedTotalCopoValue);

        if (
            // selectedCopoStatus?.length == 0 &&
            selectedKeyAccountManager?.length == 0 &&
            selectedCompany?.length === 0 &&
            selectedCopoStatusValue?.length === 0 &&
            selectedTotalCopoValue?.length === 0
        ) {
            setFilteredRows(rows);
            // setFilteredSelectedCopoStatus(selectedCopoStatus);
            setFilteredSelectedKeyAccountManager(selectedKeyAccountManager);
            setFilteredSelectedCompany(selectedCompany);
            setFilteredSelectedCopoStatusValue(selectedCopoStatusValue);
            setFilteredSelectedTotalCopoValue(selectedTotalCopoValue);
        }
    };

    const handleRemoveFilter = (category: string, item: { title: any }) => {
        if (removeFilter == true) {
            setRemoveFilter(false);
        } else {
            setRemoveFilter(true);
        }
        switch (category) {
            case "keyAccountManager":
                setSelectedKeyAccountManager((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "company":
                setSelectedCompany((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "copoStatusValue":
                setSelectedCopoStatusValue((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            case "totalCopoValue":
                setSelectedTotalCopoValue((prev) =>
                    prev.filter((i) => i.title !== item.title)
                );
                break;
            default:
                break;
        }
    };

    // Run `handleApply` after any filter changes
    useEffect(() => {
        handleApply();
        if (
            // selectedCopoStatus?.length == 0 &&
            selectedKeyAccountManager?.length == 0 &&
            selectedCompany?.length === 0 &&
            selectedCopoStatusValue?.length === 0 &&
            selectedTotalCopoValue?.length === 0
        ) {
            setIsApplyFilter(false);
        }
    }, [removeFilter]);

    const parseCustomDate = (dateStr: string) => {
        return dayjs(dateStr, "DD-MMM-YYYY HH:mm:ss").toDate();
    };

    const columns: GridColDef[] = [
        {
            headerName: "COPO ID",
            field: "COPO_ID",
            width: 100,
            disableColumnMenu: true,
            renderCell: (params) => {
                const payload = {
                    coPoData: {
                        ID: params?.value,
                        coPoID: params?.row?.ID,
                        coRfqNo: params?.row?.CORFQ_ID,
                        kamName: params?.row?.Key_Account_Manager,
                        kamID: params?.row?.KAM_ID,
                        kamImgPath: params?.row?.Key_Account_Manager_path,
                        addedOn: params?.row?.["Added_On"]
                    },
                    from: "CopoDatatable"
                };
                return (
                    <Link
                        to={"/layout/viewCoPo"}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                        state={{ payload }}
                        onClick={() => {
                            localStorage.setItem(
                                "ViewCoPo",
                                JSON.stringify(payload)
                            );
                        }}
                    >
                        {/* <AssMmrfqID value={params?.value} /> */}
                        <Chip
                            label={params?.value}
                            size="small"
                            color="default"
                        />
                    </Link>
                );
            }
        },
        {
            headerName: "COPO Number",
            field: "COPO_Number",
            width: 130,
            disableColumnMenu: true
        },

        {
            headerName: "CORFQ ID",
            field: "CORFQ_ID",
            width: 150,
            disableColumnMenu: true
        },

        {
            field: "Company_Name",
            headerName: "Company Name",
            minWidth: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                const truncatedName = name;
                const logoUrl = params.row.Company_Img_Path
                    ? generateCompanyLogo(
                          params.row.companyRecId,
                          params.row.Company_Img_Path
                      )
                    : defaultlogo;
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            height: "100%",
                            cursor: "pointer"
                        }}
                    >
                        {logoUrl && (
                            <img
                                src={logoUrl}
                                alt={name}
                                width={28}
                                height={28}
                                style={{
                                    borderRadius: "50%",
                                    border: "1px solid #D8D8D8"
                                }}
                            />
                        )}
                        <Typography variant="body2" className="hoverClr">
                            {truncatedName}
                        </Typography>
                    </Box>
                );
            }
        },

        {
            field: "Total_Order_Value",
            width: 170,
            disableColumnMenu: true,
            renderHeader: () => (
                <>
                    COPO Value
                    <Tooltip title="Excluding GST">
                        <IconButton size="small" sx={{ ml: 0.5 }}>
                            <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                </>
            ),
            renderCell: (params) => {
                const value = params.value;
                const currency = params?.row?.Currency;
                const formattedValue = formatCurrencyValue(value, currency);
                return (
                    <>
                        {getCurrencyIcon(params?.row?.Currency)}
                        {formattedValue}
                    </>
                );
            }
        },

    {
      field: "COPO_Date",
      headerName: "COPO Date",
      width: 150,
      disableColumnMenu: true
    },
...(!accountManager()
      ? [
    {
      field: "Key_Account_Manager",
      headerName: "Key Account Manager",
      width: 250,
      disableColumnMenu: true,
      renderCell: (params) => {
        const name = params.value || "";
        return (
          <Grid container spacing={2} alignItems="center" width="100%">
            <Grid size={{ xs: 2, md: 2 }}>
              <img
                src={
                  generatProfilePicUrl(
                    params.row.KAM_ID,
                    params.row.Key_Account_Manager_path,
                    "Profile_Picture"
                  ) || ""
                }
                alt="KAM"
                width={28}
                height={28}
                style={{ marginRight: "5px", borderRadius: "50%" }}
              />
            </Grid>
            <Grid size={{ xs: 10, md: 10 }}>
              <Typography variant="body2" className="">
                {name}
              </Typography>
            </Grid>
          </Grid>)}}
          ]
        : []),

        {
            headerName: "Production Manager",
            field: "Production_Manager",
            width: 180,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                return (
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        width="100%"
                    >
                        <Grid size={{ xs: 3, md: 3 }}>
                            <Avatar
                                sx={{
                                    width: 28,
                                    height: 28
                                }}
                            ></Avatar>
                        </Grid>
                        <Grid size={{ xs: 9, md: 9 }}>
                            <Typography variant="body2" className="">
                                {name}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            }
        },
        {
            headerName: "Quality Manager",
            field: "Quality_Manager",
            width: 180,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                return (
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        width="100%"
                    >
                        <Grid size={{ xs: 3, md: 3 }}>
                            <Avatar
                                sx={{
                                    width: 28,
                                    height: 28
                                }}
                            ></Avatar>
                        </Grid>
                        <Grid size={{ xs: 9, md: 9 }}>
                            <Typography variant="body2" className="">
                                {name}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            }
        },

        {
            headerName: "Added On",
            field: "Added_On",
            width: 150,
            disableColumnMenu: true
        },
        {
            headerName: "Last Updated On",
            field: "Last_Updated_On",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => (params.value ? params.value : "-"),
            sortComparator: (v1, v2) =>
                parseCustomDate(v1).getTime() - parseCustomDate(v2).getTime()
        },

        {
            headerName: "MMPO Status",
            field: "MMPO_Status",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Chip
                        size="small"
                        label={params?.value}
                        color={"default"}
                        variant={"outlined"}
                    />
                );
            }
        },
        {
            headerName: "COPO Status",
            field: "COPO_Status",
            width: 150,
            disableColumnMenu: true,
            cellClassName: () => "first-pinned-right",
            headerClassName: "first-pinned-right",
            renderCell: (params) => {
                return (
                    <Chip
                        size="small"
                        label={params?.value}
                        color={"info"}
                        variant={"outlined"}
                    />
                );
            }
        }
    ];

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            Company Purchase Orders
                        </Typography>
                    </>
                ]}
            </Breadcrumbs>
            <Typography variant="h5" mb={1}>
                Company Purchase Order
            </Typography>

            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        {allRows?.length > 1 && (
                            <Grid container spacing={2}>
                                {/* Search Section */}
                                <Grid size={{ xs: 12, md: 7 }}>
                                    <TextField
                                        label="Search by COPO ID, COPO Number & CORFQ ID"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        inputRef={searchInputRef}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </Grid>
                                {/* Filter section */}
                                <Grid
                                    size={{ xs: 12, md: 5 }}
                                    sx={{
                                        color: "grey",
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <Box>
                                        <IconButton onClick={handleClick}>
                                            <Badge
                                                badgeContent={
                                                    // filteredSelectedCopoStatus?.length +
                                                    filteredSelectedKeyAccountManager?.length +
                                                    filteredSelectedCompany?.length +
                                                    filteredSelectedCopoStatusValue?.length +
                                                    filteredSelectedTotalCopoValue?.length
                                                }
                                                color="primary"
                                            >
                                                <FilterAltOutlinedIcon />
                                            </Badge>
                                        </IconButton>

                    <Popper
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      placement="bottom-start"
                      sx={{ zIndex: 13 }}
                    >
                      <Paper
                        ref={popperRef}
                        sx={{
                          p: 2,
                          width: 350,
                          boxShadow: 3,
                          borderRadius: 2
                        }}
                      >
                        <Box
                          sx={{
                            fontWeight: "bold",
                            mb: 2,
                            display: "flex",
                            justifyContent: "space-between"
                          }}
                        >
                          Filter{" "}
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={handleClearAll}
                          >
                            CLEAR ALL
                          </Button>
                        </Box>
                        {!isFilterLoading ? (
                          <Box sx={{ mb: 2 }}>
                            {!accountManager() && (
                            <Autocomplete
                              multiple
                              size="small"
                              sx={{ marginBottom: "15px" }}
                              limitTags={2}
                              id="multiple-limit-tags"
                              options={[
                                ...(filterOptions?.keyAccountManagerOptions ||
                                  [])
                              ]?.sort((a, b) =>
                                a?.title?.localeCompare(b?.title)
                              )}
                              getOptionLabel={(option) => option?.title || ""}
                              value={selectedKeyAccountManager}
                              onChange={(event, newValue) =>
                                setSelectedKeyAccountManager(newValue || [])
                              }
                              isOptionEqualToValue={(option, value) =>
                                option.title === value?.title
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Key Account Manager"
                                  placeholder="Select Key Account Manager"
                                />
                              )}
                            />
                            )}
                            <Autocomplete
                              multiple
                              size="small"
                              sx={{ marginBottom: "15px" }}
                              limitTags={2}
                              id="copo-status-filter"
                              options={filterOptions?.copoStatusOptions || []}
                              value={selectedCopoStatusValue}
                              getOptionLabel={(option) => option?.title || ""}
                              onChange={(event, newValue) =>
                                setSelectedCopoStatusValue(newValue || [])
                              }
                              isOptionEqualToValue={(option, value) =>
                                option.title === value?.title
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="COPO Status"
                                  placeholder="Select COPO Status"
                                />
                              )}
                            />
                            <Autocomplete
                              multiple
                              size="small"
                              sx={{ marginBottom: "15px" }}
                              limitTags={2}
                              id="multiple-limit-tags"
                              options={[
                                ...(filterOptions?.companyOptions || [])
                              ]?.sort((a, b) =>
                                a?.title?.localeCompare(b?.title)
                              )}
                              value={selectedCompany}
                              onChange={(event, newValue) =>
                                setSelectedCompany(newValue || [])
                              }
                              getOptionLabel={(option) => option?.title || ""}
                              isOptionEqualToValue={(option, value) =>
                                option.title === value?.title
                              }
                              //  disabled={(selectedIndustry || []).length == 0}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Company"
                                  placeholder="Select Company"
                                />
                              )}
                            />
                            <Autocomplete
                              multiple
                              size="small"
                              sx={{ marginBottom: "15px" }}
                              limitTags={2}
                              id="total-copo-value-filter"
                              options={filterOptions?.copoValueOptions || []}
                              value={selectedTotalCopoValue}
                              getOptionLabel={(option) => option?.title || ""}
                              onChange={(event, newValue) =>
                                setSelectedTotalCopoValue(newValue || [])
                              }
                              isOptionEqualToValue={(option, value) =>
                                option.title === value?.title
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Total COPO Value"
                                  placeholder="Select Total COPO Value"
                                />
                              )}
                            />
                          </Box>
                        ) : (
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                          >
                            <ThreeDot
                              color="#1976d2"
                              size="medium"
                              text=""
                              textColor=""
                            />
                          </Box>
                        )}
                        {/* Apply / Cancel Buttons */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mt: 2
                          }}
                        >
                          <Button onClick={handleClose} color="error">
                            CANCEL
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleApply}
                          >
                            APPLY
                          </Button>
                        </Box>
                      </Paper>
                    </Popper>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                        {/* Selected Filters as Chips */}
                        {isApplyFilter == true && (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1,
                                    "& .MuiPopper-root": {
                                        zIndex: 100
                                    }
                                }}
                                mb={2}
                            >
                                {filteredSelectedKeyAccountManager?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`keyAccountManager-${index}`}
                                            label={item.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "keyAccountManager",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}

                                {filteredSelectedCompany?.map((item, index) => (
                                    <Chip
                                        key={`company-${index}`}
                                        label={item?.title}
                                        onDelete={() =>
                                            handleRemoveFilter("company", item)
                                        }
                                        size="small"
                                    />
                                ))}

                                {filteredSelectedCopoStatusValue?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`copoStatusValue-${index}`}
                                            label={item?.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "copoStatusValue",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}

                                {filteredSelectedTotalCopoValue?.map(
                                    (item, index) => (
                                        <Chip
                                            key={`totalCopoValue-${index}`}
                                            label={item?.title}
                                            onDelete={() =>
                                                handleRemoveFilter(
                                                    "totalCopoValue",
                                                    item
                                                )
                                            }
                                            size="small"
                                        />
                                    )
                                )}

                                {/* Clear All Button - Show only when filters exist */}
                                {filteredSelectedKeyAccountManager?.length +
                                    // filteredSelectedCopoStatus?.length +
                                    filteredSelectedCompany?.length +
                                    filteredSelectedCopoStatusValue?.length +
                                    filteredSelectedTotalCopoValue?.length >
                                    0 && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={handleClearAllChip}
                                        sx={{
                                            fontSize: ".75rem !important",
                                            lineHeight: "1",
                                            borderRadius: "30px"
                                        }}
                                    >
                                        CLEAR ALL
                                    </Button>
                                )}
                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Paper
                    sx={{
                        // height: 400,
                        height:
                            filteredRows?.length > 4
                                ? "62vh"
                                : filteredRows?.length > 0
                                  ? "auto"
                                  : "62vh",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    {!isLoading ? (
                        (isApplyFilter || searchTerm ? filteredRows : rows)
                            ?.length > 0 ? (
                            <>
                                <DataGridPro
                                    rows={
                                        isApplyFilter || searchTerm
                                            ? filteredRows
                                            : rows
                                    }
                                    columns={columns}
                                    getRowId={(row) => row?.id}
                                    getRowHeight={() => "auto"}
                                    pagination={
                                        (isApplyFilter || searchTerm
                                            ? filteredRows
                                            : rows
                                        )?.length > 10
                                    }
                                    rowSelectionModel={selectedRows}
                                    pinnedColumns={pinnedColumns}
                                    onPinnedColumnsChange={
                                        handlePinnedColumnsChange
                                    }
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    pageSizeOptions={[10, 20]}
                                    disableRowSelectionOnClick={true}
                                    initialState={{
                                        sorting: {
                                            sortModel: [
                                                {
                                                    field: "Last_Updated_On",
                                                    sort: "desc"
                                                }
                                            ]
                                        }
                                    }}
                                />
                            </>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "8px",
                                    padding: "20px"
                                }}
                            >
                                {/* If user searched and original rows are empty */}
                                {searchTerm || allRows?.length > 0 ? (
                                    "No Options available"
                                ) : isApplyFilter &&
                                  (!filteredRows ||
                                      filteredRows.length === 0) ? (
                                    // When filters are applied but no results
                                    "No results for applied filters"
                                ) : (
                                    // Default empty state
                                    <>
                                        <img
                                            src={emptyImage}
                                            alt="Empty"
                                            width="300px"
                                        />
                                        <b style={{ color: "#0009" }}>
                                            All Company Purchase Order Will
                                            Appear here
                                        </b>
                                    </>
                                )}
                                {/* <>
                  <img src={emptyImage} alt="Empty" width="300px" />
                  <b style={{ color: "#0009" }}>
                    All Proposals Will Appear here
                  </b>
                </> */}
                            </div>
                        )
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Paper>
            </Box>
        </>
    );
};
